<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-receipt">&nbsp; Invoices</h5>
        </div>
        <div class="col-auto text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadInvoices()" :disabled="loading">&nbsp; Reload</button>
        </div>
        <div class="col-auto p-0">
          <button class="btn w-100 btn-success bi-file-earmark-excel-fill" @click="xlsx()" :disabled="loading">&nbsp; Excel</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="branch" @change="loadInvoices()">
              <option value="*">All Branches</option>
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
          <!-- <div class="input-group w-100">
            <span class="input-group-text">Search</span>
            <input class="form-control" type="text" v-model.trim="searchKey" @change="loadInvoices()">
            <button class="btn btn-primary bi-search" @click="loadInvoices()" :disabled="loading"></button>
          </div> -->
        </div>
        
        <div class="col-9 pe-0">
          <div class="input-group w-100">
            <span class="input-group-text">From</span>
            <input class="form-control w-20" type="date" v-model="from">
            <span class="input-group-text">To</span>
            <input class="form-control w-20" type="date" v-model="to">
            <span class="input-group-text">Keyword</span>
            <input class="form-control" type="text" placeholder="invoice id or customer name, phone, or car" v-model="searchKey">
            <button class="btn btn-primary bi-filter" @click="loadInvoices()" :disabled="loading"></button>
          </div>
        </div>
        
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-20">Date</th>
          <th class="w-10">Branch</th>
          <th class="w-8">Cashier</th>
          <th class="">Customer</th>
          <th class="w-10 text-center">Type</th>
          <th class="w-10 text-center">Value</th>
          <th class="w-10 text-center">Left</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="invoice in invoices" :key="invoice._id" v-bind:class="invoice.left > 0 ? 'table-danger' : ''">
          <td class="w-20 position-relative">
            {{ invoice.date }}
            <span v-if="invoice.returned" class="badge text-bg-danger returned-badge" title="Returned">
              <i class="bi-bootstrap-reboot"></i>
            </span>
          </td>
          <td class="w-10">{{ invoice.branch }}</td>
          <td class="w-8">{{ invoice.cashier == 'super' ? '' : invoice.cashier }}</td>
          <td class="">{{ invoice.customer }}</td>
          <td class="w-10 text-center">{{ invoice.type }}</td>
          <td class="w-10 text-center">{{ formatMoney(invoice.total) }}</td>
          <td class="w-10 text-center">{{ formatMoney(invoice.left) }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item bi-eye" @click="viewInvoice(invoice._id)">View</a></li>
              <li v-if="invoice.left > 0"><a class="dropdown-item bi-cash text-primary" @click="payPart(invoice._id)">Pay Part</a></li>
              <li v-if="$store.getters.access('sales_return')"><a class="dropdown-item bi-arrow-counterclockwise" @click="returnInvoice(invoice._id)">Return</a></li>
              <li v-if="$store.getters.isSuper"><a class="dropdown-item bi-trash text-danger" @click="delInvoice(invoice._id)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <Invoice ref="invoice"></Invoice>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="payPartModal" ref="payPartModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">PayPart: {{ paypart.invoice_id }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Date</span>
              <span class="input-group-text w-60">{{ paypart.date }}</span>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Customer</span>
              <span class="input-group-text w-60">{{ paypart.customer }}</span>
            </div>

            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-40">Invoice Total</span>
              <span class="input-group-text w-60 text-center d-block select">{{ formatMoney(paypart.total) }}</span>
            </div>

            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-40 text-success">Paid</span>
              <span class="input-group-text w-60 text-success text-center d-block select">{{ formatMoney(paypart.paid) }}</span>
            </div>

            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-40 text-danger">Remaining</span>
              <span class="input-group-text w-60 text-danger text-center d-block select">{{ formatMoney(paypart.total - paypart.paid) }}</span>
            </div>

            <hr>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-40">Payment Type</span>
              <select class="form-select" v-model="paypart.method" @change="methodChanged()">
                <option value='cash'>Cash</option>
                <option value='visa'>Visa</option>
              </select>
            </div>

            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-40 text-success">Paid</span>
              <input type="number" class="form-control text-success text-center" v-model.number="paypart.value">
            </div>
                        
            
            <div v-if="paypart.method == 'visa'">
              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-40">Transaction ID</span>
                <input type="text" class="form-control" v-model="paypart.ref_num">
              </div>
            </div>
            
            <div class="input-group w-100 mb-2 fw-bold">
              <span class="input-group-text w-40 text-center">Remaining</span>
              <span class="input-group-text w-60 text-center d-block select">{{ formatMoney(paypart.total - paypart.paid - paypart.value) }}</span>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <button class="btn btn-success w-100" @click="confirmPayPart()">Pay</button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  // const bootstrap = require('bootstrap');
  import Invoice from '@/components/Invoice.vue';
  // eslint-disable-next-line
  export default {
    name: 'InvoicesPage',
    props: {
      cid: {
        type: String,
        required: false,
        default: '',
      },
    },
    components: {
      Invoice
    },
    data(){
      return {
        loading: false,
        
        branches: [],
        invoices: [],

        branch: '*',
        searchKey: '',
        from: '',
        to: '',

        paypart:{
          date: '',
          invoice_id: '',
          customer: '',
          total: 0,
          paid: 0,

          method: 'cash',
          ref_num: '',
          value: 0,
        }
      }
    },
    async created(){
      await this.loadBranches();
      if(this.$route.params.cid){
        this.searchKey = this.$route.params.cid;
        this.from = this.$getEpochStart();
        this.to = this.$getCurrentDay();
      }
      else{
        this.from = this.$getMonthStart();
        this.to = this.$getNextMonthStart();
        // this.to = this.$getMonthEnd();
      }
      await this.loadInvoices();

      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;
        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadInvoices(){
        this.loading = true;
        this.invoices = [];
        var ack = await this.$service.getInvoices({
          searchKey: this.searchKey,
          branch: this.branch,
          from: this.from,
          to: this.to,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.invoices = ack.data;
          // let arr = Array.from(document.getElementsByClassName('tooltip'));
          // arr.forEach((x)=>new bootstrap.Tooltip(x));
        }
        this.loading = false;
      },
      //**********************************************************
      async xlsx(){
        this.loading = true;
        var ack = await this.$service.getInvoices({
          searchKey: this.searchKey,
          branch: this.branch,
          from: this.from,
          to: this.to,
          xlsx: true,
        }, 'blob');
        if(!ack){
          this.$toast('Error');
        }
        else{
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(ack.blob);
          link.download = ack.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        
        this.loading = false;
      },
      //**********************************************************
      async viewInvoice(invoice_id){
        this.loading = true;
        await this.$refs.invoice.view(invoice_id);
        this.loading = false;
      },
      //**********************************************************
      async onBarcodeScan(code){
        this.searchKey = code;
      },
      //**********************************************************
      async returnInvoice(invoice_id){
        this.$router.push({
            name: 'Return',
            params: { id: invoice_id }
        })
        // var reply = await this.$swal.fire({
        //   title: "Confirm Delete",
        //   html: `Are you sure you want to delete the Invoice <b>${invoice_id}</b>`,
        //   icon: "error", showCancelButton: true, focusCancel: true,
        //   confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        // });
        // if(!reply.isConfirmed) return;
        // this.loading = true;
        // var ack = await this.$service.delInvoice({ id: invoice_id});
        // if(ack.state != 'OK'){
        //   this.$toast(ack.state);
        // }
        // else{
        //   this.$toast('Invoice Deleted Successfuly', 'success');
        //   this.loadInvoices();
        // }
        // this.loading = false;
      },
      //**********************************************************
      async delInvoice(invoice_id){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the Invoice <b>${invoice_id}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delInvoice({ id: invoice_id});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Invoice Deleted Successfuly', 'success');
          this.loadInvoices();
        }
        this.loading = false;
      },
      //**********************************************************
      async payPart(invoice_id){
        this.loading = true;
        var ack = await this.$service.getInvoice({ id: invoice_id });
        if(ack.state != 'OK'){
          this.loading = false;
          return this.$toast(ack.state);
        }
        this.paypart.invoice_id = invoice_id;
        this.paypart.date = ack.data.date;
        this.paypart.customer = ack.data.customerName;
        this.paypart.total = ack.data.total;
        this.paypart.paid = ack.data.paid;
        this.loading = false;
        $('#payPartModal').modal('show');
      },
      //**********************************************************
      async confirmPayPart(){
        if(this.paypart.value <= 0){
          return this.$toast('invalid amount');
        }
        if(this.paypart.method == 'visa' && !this.paypart.ref_num){
          return this.$toast("Please enter a reference number");
        }
        this.loading = true;
        var ack = await this.$service.payPart({
          invoice_id: this.paypart.invoice_id,
          method: this.paypart.method,
          ref_num: this.paypart.ref_num,
          value: this.paypart.value,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Invoice Paid Successfuly', 'success');
          $('#payPartModal').modal('hide');
          await this.loadInvoices();
        }
        this.loading = false;
        
      },
      //**********************************************************
      async methodChanged(){
        if(this.paypart.method == 'cash'){
          this.paypart.value = 0;
        }
        else if(this.paypart.method == 'visa'){
          this.paypart.value = this.paypart.total - this.paypart.paid;
        }
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.returned-badge{
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
  